document.addEventListener("DOMContentLoaded", () => {
  const $howToBlocks = Array.from(
    document.querySelectorAll(".how-to")
  )
  if ($howToBlocks.length) {
    for (const $howToBlock of $howToBlocks) {
      const blocks = $howToBlock.querySelector(".how-to__blocks")

      // Close all other details when one is shown
      blocks.addEventListener("sl-show", (event) => {
        if (event.target.localName === "sl-details") {
          ;[...blocks.querySelectorAll("sl-details")].map(
            (details) => (details.open = event.target === details)
          )
        }
      })

      // Desktop
      const defaultImg = $howToBlock.querySelector(
        ".how-to__image-default"
      )
      const allImgElem = $howToBlock.querySelectorAll(
        ".how-to__image img"
      )
      const items = $howToBlock.querySelectorAll(".how-to__item")
      items.forEach((item) => {
        item.addEventListener("mouseenter", (event) => {
          const imgElem = $howToBlock.querySelector(
            `.how-to__image-${item.dataset.index}`
          )
          allImgElem.forEach((img) => img.classList.add("transparent"))
          if (imgElem) {
            imgElem.classList.remove("transparent")
          }
        })
      })

      $howToBlock.addEventListener("mouseleave", (event) => {
        allImgElem.forEach(
          (img) => img !== defaultImg && img.classList.add("transparent")
        )
        if (defaultImg) {
          defaultImg.classList.remove("transparent")
        }
      })
    }
  }
})

